import {get} from '../../../api';
import StyledButton from '../../cmp/themed/StyledButton';
import {PencilIcon, PlusIcon, TrashIcon} from '../../../icons/Icons';
import {useCallback, useEffect, useState} from 'react';
import LeadCaptureFormComponent from './LeadCaptureFormComponent';
import Collapse from 'reactstrap/lib/Collapse';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';

export default function ViewAndAddLeads({formId}){
  const [data, setData] = useState([])
  const [formConfig, setFormConfig] = useState(null)
  const [metadata, setMetadata] = useState(null)
  const [loading, setLoading] = useState(false)
  const loadData = useCallback(()=>{
    setLoading(true)
    get('/form-lead/'+formId).then((data)=>{
      setData(data.data)
      setFormConfig(data.formConfig)
      setMetadata(data.metadata)
      setLoading(false)
    })
  },[formId])
  useEffect(()=>{
    loadData()
  },[loadData])
  const [editFormData, setEditFormData] = useState(null)
  const [visible, setVisible] = useState(false)
  const onEditClicked = useCallback((id)=>{
    return ()=>{
      setEditFormData(data.find((i)=>i._id == id))
      setVisible(true)
    }
  },[data])
  const toggle = useCallback(()=>{
    setEditFormData(null)
    setVisible((v)=>!v)
  },[])
  return <>
    <div className="d-flex align-items-center justify-content-between mb-2">
      <h3 className={"mb-0"}>{metadata?.title || ''}</h3>
      <StyledButton onClick={toggle}>
        <PlusIcon /> {metadata?.btnTitle || ''}
      </StyledButton>
    </div>
    {
      metadata?.description ?
          <p>{metadata?.description}</p> : null
    }
    <Collapse isOpen={visible}>
      <div className="bg-light rounded border p-3">
        <LeadCaptureFormComponent onSubmit={loadData} formData={editFormData} formId={formId} />
      </div>
    </Collapse>
    <div className="row flex-wrap mt-2">
      {
        loading ?<> <div className={"col-md-4"}>
          <LoadingSkeleton height={100} />
        </div>
          <div className={"col-md-4"}>
            <LoadingSkeleton height={100} />
          </div><div className={"col-md-4"}>
            <LoadingSkeleton height={100} />
          </div>
        </> : null
      }
      {
        !loading && data.length > 0 ? data.map((i)=>{
          return <div className={"col-md-4 col-lg-4"} key={String(i._id)}>
            <div className="card">
              <div className="card-header">
                {
                  i.customer_name ? <div>{i.customer_name}</div> : null
                }
                <span className={"text-muted"}>{i.customer_email}</span>
              </div>
              {
                i.data && Object.keys(i.data).length > 0 ? <>
                  <div className="px-3 pt-3">
                    {
                      Object.keys(i.data).map((key)=>{
                        return <div key={String(key)}>
                          <strong>{key}</strong>
                          <p>{i.data[key]}</p>
                        </div>
                      })
                    }
                  </div>
                </> : null
              }
              <div className="card-footer d-flex align-items-center justify-content-between">
                <span>
                  <button className={"btn d-none btn-sm btn-link text-muted"}><TrashIcon /></button>
                </span>
                <button className={"btn btn-sm btn-link text-muted"} onClick={onEditClicked(i._id)}><PencilIcon/></button>
              </div>
            </div>
          </div>
        }) : null
      }
    </div>
  </>
}
